import logo from "../images/crizgames_logo.svg";
import "../styles/customTheme.css";

import React from "react";
import { useMediaQuery } from "react-responsive";
import { useStaticQuery, graphql, Link } from "gatsby";
//import useScreenType from "../hooks/useScreenType"

const useScreenType = () => {
  const fullscreen = useMediaQuery({ minWidth: 500 });
  const mobile = useMediaQuery({ minWidth: 300 });

  if (fullscreen) {
    return "fullscreen";
  }

  return "mobile";
};

export default function Menu({ selectedKey, children }) {
  const data = useStaticQuery(graphql`
    query ContainerQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

    const screenType = useScreenType();

  // Set selectedKey to MenuItems
  const childrenWithProps = React.Children.map(children, child => {
    // checking isValidElement is the safe way and avoids a typescript error too
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { selectedKey, screenType });
    }
    return child;
  });

  return (
    <div className="top-0 z-40 w-full max-w-4xl mx-auto bg-white flex items-stretch ">
      <div className="w-full md:w-auto">
        <Link
          to="/"
          className="flex flex-row px-4 py-4 min-w-full border-b md:border-b-0 border-gray-200"
        >
          <img src={logo} className="mr-3 h-8" alt="logo"></img>
          <h1
            className="text-lg mt-px"
            style={{
              color: "rgba(0,0,0,0.85)",
            }}
          >
            {data.site.siteMetadata.title}
          </h1>
        </Link>
        {screenType === "mobile" && childrenWithProps}
      </div>
      {screenType === "fullscreen" && (
        <div
          className={
            screenType === "fullscreen"
              ? "flex items-stretch self-end px-4 py-2 mr-0 ml-auto"
              : ""
          }
        >
          {childrenWithProps}
        </div>
      )}
    </div>
  );
}

export function MenuItem({ selectedKey, pageKey, link, children, screenType }) {
  return (
    <Link
      to={link}
      className={
        "flex flex-row px-4 py-4 text-base text-black border-b md:border-b-0 border-gray-200" +
        (selectedKey === pageKey ? " font-medium text-blue-600" : "")
      }
    >
      <div className="w-full transition-colors duration-100 ease-in-out hover:text-blue-600">
        {children}
      </div>
    </Link>
  );
}
